import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import api from '../services/api';

/**
 * lot DJ — UN SEUL appel au compteur pour tout l'écran : au chargement, toutes les 60 s, au
 * retour sur l'onglet et après chaque lecture.
 * ⛔ Aucune dépendance instable ici : un `useEffect` mal fermé provoquait 20 requêtes/seconde.
 */
const NotificationsContext = createContext({
  nonLues: 0, total: 0, bandeau: false, parType: {}, rafraichir: () => {}, fermerBandeau: () => {},
});

export const useNotifications = () => useContext(NotificationsContext);

export const NotificationsProvider = ({ children }) => {
  const [etat, setEtat] = useState({ nonLues: 0, total: 0, bandeau: false, parType: {} });
  const enCours = useRef(false);

  const rafraichir = useCallback(async () => {
    if (enCours.current || !localStorage.getItem('token')) return;
    enCours.current = true;
    try {
      const { data } = await api.get('/notifications/compteur');
      setEtat({ nonLues: data.non_lues || 0, total: data.total || 0, bandeau: !!data.bandeau,
        parType: data.par_type || {} });
    } catch (_) {
      /* silencieux : la cloche n'est pas un écran bloquant */
    } finally {
      enCours.current = false;
    }
  }, []);

  useEffect(() => {
    rafraichir();
    const minuteur = setInterval(rafraichir, 60000);
    const surRetour = () => { if (document.visibilityState === 'visible') rafraichir(); };
    document.addEventListener('visibilitychange', surRetour);
    return () => {
      clearInterval(minuteur);
      document.removeEventListener('visibilitychange', surRetour);
    };
  }, [rafraichir]);

  const fermerBandeau = useCallback(async () => {
    setEtat((e) => ({ ...e, bandeau: false }));
    try { await api.post('/notifications/bandeau/fermer'); } catch (_) { /* sans gravité */ }
  }, []);

  return (
    <NotificationsContext.Provider value={{ ...etat, rafraichir, fermerBandeau }}>
      {children}
    </NotificationsContext.Provider>
  );
};

export default NotificationsProvider;
